export enum DESTINATIONS {
	MAX_QUANTITY = 8,
}

export enum MOBILE {
	OFFSET_TOP = 16,
}
